import React, {useState} from "react";
import {useIntl} from "react-intl";
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";
import FormatDate from "../Utils/FormatDate";
import ContextMenu from "../Utils/ContextMenu";
import MenuItem from "./MenuItem";
import Amount from "../Utils/Amount";
import Icon from "../Utils/Icon";
import Api from "../../Api";
import classes from "../RegistryTable/styles.module.css";

function TableRow({
                      token,
                      id,
                      name,
                      date,
                      status,
                      tags,
                      success,
                      failed,
                      other,
                      retry,
                      amount,
                      totalFee,
                      currency,
                      merchantUUID,
                      merchantName,
}) {
    const intl = useIntl();
    const history = useHistory();
    const [isRetry, setIsRetry] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(status);
    const [transactions, setTransactions] = useState({success, failed, other});

    const handleClickDetail = () => {
        history.push(`/payouts/registry/${id}`);
    };

    const regStatus = (() => {
        switch (currentStatus) {
            case "created":
                return {
                    name: <FormattedMessage id="RegistryList.status.created" defaultMessage="Создан"/>,
                    color: "#ff9800"
                };
            case "inProgress":
                return {
                    name: <FormattedMessage id="RegistryList.status.inProcessing" defaultMessage="Обрабатывается"/>,
                    color: "#a29d9d"
                };
            case "processed":
                return {
                    name: <FormattedMessage id="RegistryList.status.processed" defaultMessage="Выполнен"/>,
                    color: "#35C98E"
                };
            case "processedWithErrors":
                return {
                    name: <FormattedMessage id="RegistryList.status.processedWithErrors"
                                            defaultMessage="Выполнен с ошибками"/>, color: "#f44336"
                };
            case "delayed":
                return {
                    name: <FormattedMessage id="RegistryList.status.delayed" defaultMessage="Ожидание"/>,
                    color: "#2479E0"
                };
            default:
                return {
                    name: <FormattedMessage id="RegistryList.status.reprocess" defaultMessage="Повторная обработка"/>,
                    color: "#ff9800"
                };
        }
    })();

    function Reprocess() {
        if (
            !window.confirm(
                intl.formatMessage(
                    {
                        id: "RegistryList.confirm.reprocess",
                        defaultMessage: 'Обработать повторно реестр "{name}"?',
                    },
                    {name}
                )
            )
        ) return;

        new Api({token})
            .setRegistryReprocess(id)
            .then((r) => {
                if (!r.error) {
                    setIsRetry(true);
                    setCurrentStatus("reprocess");

                    setTimeout(() => {
                        new Api({token})
                            .getRegistryStatus(id)
                            .then((res) => {
                                if (retry) setIsRetry(false);
                                setTransactions({success: res.success, failed: res.failed, other: res.other});
                                setCurrentStatus(res.status);
                            });
                    }, 3000);
                }
            });
    }

    function getReport(id) {
        const fileName = name.replace(".xls", "") + " - " + date;
        new Api({token}).getReport("singleRegistry", id, fileName);
    }

    function downloadRegistry(id) {
        const base = (name || `registry_${id}`).replace(/\.xlsx$/i, "").replace(/\.xls$/i, "");
        new Api({token}).downloadRegistryFile(id, base);
    }


    return (
        <tr className={classes.Row}>
            <td className={classes.CellCenter}>{id}</td>
            <td className={classes.Cell}>
                {name}
                <div>
          <span className={classes.Status} style={{color: regStatus.color}}>
            {regStatus.name}
          </span>
                    &nbsp;(
                    <span className={classes.Success}>{transactions.success}</span>/
                    <span className={classes.Failed}>{transactions.failed}</span>/

                    <span className={classes.Other}>{transactions.other}</span>)
                </div>
            </td>
            <td className={classes.Cell}>{merchantName}</td>
            <td className={classes.Cell}>
        <span className={classes.Date}>
          <FormatDate setDate={date} format={{day: "numeric", month: "numeric", year: "numeric"}}/>
          <br/>
          <FormatDate setDate={date} format={{hour: "numeric", minute: "numeric"}}/>
        </span>
            </td>
            <td className={classes.Cell}>
                <Amount amount={amount} currency={currency}/>
            </td>
            <td className={classes.Cell}>
                <Amount amount={totalFee} currency={currency}/>
            </td>
            <td className={classes.Cell}>
                {tags &&
                    tags.map((tag, index) => (
                        <span key={index} className={classes.Tag}>
              {tag.name}
            </span>
                    ))}
            </td>
            <td className={classes.CellMenu}>
                <ContextMenu icon="menu">
                    <ul>
                        <MenuItem handleClickDetail={handleClickDetail} access={["PAYOUT_REGISTRY_VIEW"]}
                                  merchantUUID={merchantUUID}/>

                        {retry && (
                            <li
                                className={`${classes.MenuItem} ${isRetry && classes.MenuItemDisabled}`}
                                onClick={() => !isRetry && Reprocess()}
                            >
                                <Icon className={classes.MenuIcon} icon="spinner11" size="14px"/>
                                <FormattedMessage id="RegistryList.menu.reprocess"
                                                  defaultMessage="Обработать повторно"/>
                            </li>
                        )}

                        <li className={classes.MenuItem} onClick={() => getReport(id)}>
                            <Icon className={classes.MenuIcon} icon="file-excel" size="14px"/>
                            <FormattedMessage id="RegistryList.menu.report" defaultMessage="Выгрузить отчет"/>
                        </li>

                        <li className={classes.MenuItem} onClick={() => downloadRegistry(id)}>
                            <Icon className={classes.MenuIcon} icon="file-excel" size="14px"/>
                            <FormattedMessage id="RegistryList.menu.downloadRegistry"
                                              defaultMessage="Выгрузить реестр"/>
                        </li>

                    </ul>
                </ContextMenu>
            </td>
        </tr>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/RegistryList/TableRow.js